import * as React from 'react';
import { FelaComponent, Container } from '@filou/core';
var Banner = function (_a) {
    var src = _a.src, title = _a.title, description = _a.description;
    return (React.createElement(FelaComponent, { style: {
            position: 'relative',
            color: 'white',
            '> div > div > h1': {
                fontSize: 30,
                fontWeight: 400,
                margin: 0
            },
            '> div > div > h2': {
                fontSize: 18,
                fontWeight: 400,
                margin: 0
            },
            '> div > div': {
                paddingY: 20
            },
            overflow: 'hidden',
            background: "url(" + src + ") no-repeat center center",
            backgroundSize: 'cover',
            top: 0,
            left: 0,
            width: '100%'
        } },
        React.createElement(Container, null,
            React.createElement("h1", null, title),
            React.createElement("h2", null, description))));
};
export default Banner;
//# sourceMappingURL=index.js.map